
import { Vue, Prop, Component } from "vue-property-decorator";

@Component({
  components: {
    MultiSelectBt: () => import("../Common/MultiSelectBt.vue")
  }
})
export default class MenuMobile extends Vue {
  list_menu = [
    {
      name: "Crea tu perfil",
      link: "/bienvenida"
    },
    {
      name: "Mi Perfil",
      link: "/perfil"
    }
  ];
  optSearch = [
    {
      section: "Puesto",
      info: [
        { name: "Ejecutiva de cuentas", category: "ejecutiva" },
        { name: "Ejecutiva de ventas", category: "ejecutiva" },
        { name: "Secretaria ejecutiva", category: "ejecutiva" },
        { name: "Asistente ejecutiva", category: "ejecutiva" }
      ]
    },
    {
      section: "Área",
      info: [
        { name: "Recursos Humanos", category: "rrhh" },
        { name: "Gerencia", category: "gerencia" }
      ]
    }
  ];
  options = [
    "Select option",
    "Buenos Aires, Argentina",
    "Santa Fe, Argentina",
    "Mendoza, Argentina",
    "Córdoba, Argentina"
  ];
  reloadPage() {
    window.location.reload();
  }
}
